// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"484":"94e5ccff","975":"0c3f8f7d"}[chunkId] + ".chunk.css";
};